var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/contentful-logo-asset.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.headerFeatureConfig.logo"]));
frame.set("logo_config", t_1, true);
if(frame.topLevel) {
context.setVariable("logo_config", t_1);
}
if(frame.topLevel) {
context.addExport("logo_config", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["logo_config.fields.primaryImage"]));
frame.set("small_logo", t_2, true);
if(frame.topLevel) {
context.setVariable("small_logo", t_2);
}
if(frame.topLevel) {
context.addExport("small_logo", t_2);
}
output += "\n";
var t_3;
t_3 = (lineno = 2, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["logo_config.fields.alternateImage"]));
frame.set("large_logo", t_3, true);
if(frame.topLevel) {
context.setVariable("large_logo", t_3);
}
if(frame.topLevel) {
context.addExport("large_logo", t_3);
}
output += "\n";
var t_4;
t_4 = "(min-width: 768px)";
frame.set("mediaQuery", t_4, true);
if(frame.topLevel) {
context.setVariable("mediaQuery", t_4);
}
if(frame.topLevel) {
context.addExport("mediaQuery", t_4);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "small_logo") && runtime.contextOrFrameLookup(context, frame, "large_logo")) {
output += "\n\n    <picture>\n\n        <source media=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "mediaQuery"), env.opts.autoescape);
output += "\" srcset=\"";
output += runtime.suppressValue(env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "large_logo")), env.opts.autoescape);
output += "\" />\n\n        <img src=\"";
output += runtime.suppressValue(env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "small_logo")), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue((lineno = 11, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["site-logo-title"])), env.opts.autoescape);
output += "\" />\n\n    </picture>\n\n";
;
}
else {
output += "\n\n    <img src=\"";
output += runtime.suppressValue(env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "small_logo")), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue((lineno = 17, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["site-logo-title"])), env.opts.autoescape);
output += "\" />\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/contentful-logo-asset.j2"] , dependencies)